import { render, staticRenderFns } from "./UploadWhatsappFileModal.vue?vue&type=template&id=05567a17&scoped=true&"
import script from "./UploadWhatsappFileModal.vue?vue&type=script&lang=js&"
export * from "./UploadWhatsappFileModal.vue?vue&type=script&lang=js&"
import style0 from "./UploadWhatsappFileModal.vue?vue&type=style&index=0&id=05567a17&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05567a17",
  null
  
)

export default component.exports